/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { SuccessNotificationComponent } from '../../notification-components/system-notifications/success-notification-component';
import { withNotificationComponent } from '../base';
import { SystemNotification } from './system-notification';

/**
 * Represents a success notification.
 * Use this notification for the successful scenarios when you want to display a simple message to the user.
 * This is one of the types of system notifications.
 */
@withNotificationComponent(SuccessNotificationComponent)
export class SuccessNotification extends SystemNotification { }